var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 .7h22v22.6H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 18.2c-1.9.1-3.7-.5-5.3-1.5-1.5-1.1-2.7-2.7-3.3-4.4l-.1-.3c.6-1.9 1.8-3.5 3.4-4.7 1.6-1.1 3.5-1.6 5.4-1.6 1.9-.1 3.8.5 5.4 1.6 1.6 1.2 2.8 2.8 3.4 4.7l-.1.3c-.7 1.8-1.9 3.3-3.4 4.4-1.6 1.1-3.5 1.6-5.4 1.5zM12 8c-2.1 0-3.9 1.8-3.8 4 0 2.2 1.7 3.9 3.8 3.9 2.2 0 3.9-1.8 3.8-3.9.1-2.2-1.6-4-3.8-4zm0 6.1c-1.2 0-2.1-.9-2.1-2s.9-2.1 2-2.1 2.1.9 2.1 2v.1c0 1-.9 2-2 2z",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyesWhite);
export default __webpack_public_path__ + "static/media/ic_eyes_white.362b4b469720a574f0aad34e75d0ba05.svg";
export { ForwardRef as ReactComponent };